import React from 'react';
import './pages_header.css';

export const PagesHeader = ({ IconComponent, title, subtitle, leading, extraLeft, actions }) => {
  return (
    <header className="pages-header">
      <div className="pages-header__left">
        <div className="pages-header__titles d-flex align-items-center">
          {leading && <div className="pages-header__leading mr-3">{leading}</div>}
          {IconComponent && (
            <div className="pages-header__icon mr-3">
              <IconComponent />
            </div>
          )}
          <div>
            {title && <h5 className="pages-header__title">{title}</h5>}
            {subtitle && <small className="pages-header__subtitle">{subtitle}</small>}
          </div>
        </div>

        {extraLeft && <div className="pages-header__extra">{extraLeft}</div>}
      </div>

      {actions && <div className="pages-header__actions">{actions}</div>}
    </header>
  );
};
